import { gql } from '@/lib/graphql/gql'

export const BILLING_PERIOD_QUERY = gql`
  query DashboardBillingPeriod($idCompany: String!) {
    company(id: $idCompany) {
      id
      sevallaBilling {
        id
        subscription {
          id
          currentPeriodStart
          currentPeriodEnd
        }
      }
    }
  }
`
